import { render, staticRenderFns } from "./AddLesson.vue?vue&type=template&id=802d056a"
import script from "./AddLesson.vue?vue&type=script&lang=js"
export * from "./AddLesson.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports